import { render } from "./ProductsSelectionStep.vue?vue&type=template&id=01e80e68"
import script from "./ProductsSelectionStep.vue?vue&type=script&lang=js"
export * from "./ProductsSelectionStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__